// Module
var code = `<div class="product-updates-iframe-container"> <iframe ng-src="{{\$ctrl.blipProductUpdatesUrl}}" width="100%" height="100%" frameborder="0" allowfullscreen></iframe> </div>`;
// Exports
module.exports = code;